export default __webpack_public_path__ + "static/media/img-2.dac4be2a.png";